<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-11">
          <h4><u>Πληρωμές</u></h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <DxSelectBox
          :search-enabled="true"
          :data-source="months"
          search-mode="contains"
          search-expr="Description"
          :search-timeout="200"
          :min-search-length="2"
          :show-data-before-search="true"
          display-expr="Description"
          value-expr="Id"
          v-model="selectedMonthId"
          @value-changed="setSelectedMonth"
          placeholder="Επιλέξτε Μήνα"
          :show-clear-button="true"
        />
      </div>
      <div class="col-md-3">
        <br />
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 grid-pad">
        <DxDataGrid
          ref="payments"
          @initialized="saveGridInstance"
          :data-source="payments"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :show-borders="true"
          :show-row-lines="true"
          :row-alternation-enabled="true"
          width="100%"
        >
          <DxPaging :page-size="20" :enabled="true" />
          <DxEditing :allow-updating="false" :use-icons="true" mode="cell" />
          <DxHeaderFilter :visible="true" />
          <DxFilterRow :visible="true" />
          <DxSearchPanel :visible="true" />

          <DxColumn
            caption="Ημερομηνία"
            :allow-editing="false"
            data-field="PaymentDate"
            data-type="date"
            :visible="false"
            width="200px"
            alignment="center"
            format="dd/MM/yyyy"
            :allow-filtering="true"
          >
          </DxColumn>
          <DxColumn
            caption="Περιγραφή"
            :allow-editing="false"
            data-field="Description"
            data-type="string"
            :visible="true"
            width="400px"
            alignment="left"
          >
          </DxColumn>
          <DxColumn
            caption="Τύπος χρηματοδότησης"
            :allow-editing="false"
            data-field="FundingTypeDto.Description"
            data-type="string"
            :visible="true"
            width="400px"
            sort-order="asc"
            alignment="left"
          >
          </DxColumn>
          <DxColumn
            caption="Ολοκληρωμένη"
            :allow-editing="false"
            data-field="IsFinalized"
            data-type="boolean"
            :visible="true"
            width="120px"
            alignment="center"
          >
          </DxColumn>
          <DxColumn type="buttons">
            <!-- <DxButton hint="Web viewer" icon="info" :on-click="onPaymentInfoViewerClick"/> -->
            <DxButton
              hint="Οριστικοποίηση"
              icon="exportselected"
              :on-click="onFinalizeClick"
              :visible="isNotFinalized"
            />

            <DxButton
              hint="Βήματα Ολοκλήρωσης"
              icon="cellproperties"
              :on-click="onPaymentWizardClick"
              :visible="isFinalized"
            />
            <DxButton
              hint="Αναίρεση Οριστικοποίησης ΣΚΠ"
              icon="undo"
              :on-click="onUndoFinalization"
              :visible="isVisible"
            />
            <DxButton
              hint="Εκτύπωση"
              icon="print"
              :on-click="onPaymentInfoDownloadClick"
              :visible="false"
            />
            <DxButton
              hint="Ανέβασμα εγγράφων"
              icon="upload"
              :on-click="onUploadClick"
              :visible="false"
            />
          </DxColumn>
          <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
          <template #masterDetailTemplate="{ data: masterrow }">
            <DetailTemplate
              ref="paymentDetails"
              :template-data="masterrow"
              :duplicateReceiptNumbers="duplicateReceiptNumbers"
              @detailSaved="updateFinalizeCheck"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
    <paymentsUploadDocuments
      v-if="uploadPopupIsVisible"
      :isVisible="uploadPopupIsVisible"
      :paymentId="selectedPaymentId"
      v-on:emit-close-popup="HidePopup"
    />

    <paymentWizard
      v-if="wizardPopupIsVisible"
      :isVisible="wizardPopupIsVisible"
      :paymentId="selectedPaymentId"
      :organizationId="organizationId"
      v-on:emit-close-popup="HideWizardPopup"
    />

    <DxPopup
      :visible="finalizationPopupIsVisible"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :show-title="true"
      :show-close-button="true"
      :width="500"
      :height="150"
      title="Οριστικοποίηση"
    >
      <div class="row">
        Είστε σίγουροι ότι θέλετε να οριστικοποιήσετε τη συγκεκριμένη ΣΚΠ;
      </div>

      <div class="row" style="padding-top: 20px">
        <DxButton2
          class="pull-right"
          text="Ναι"
          type="success"
          :width="120"
          styling-mode="contained"
          @click="onFinalizationApprove"
        />
        <DxButton2
          text="Όχι"
          type="danger"
          :width="120"
          styling-mode="contained"
          @click="onClosePopup"
        />
      </div>
    </DxPopup>

    <DxPopup
      :visible="undoFinalizationPopupIsVisible"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :show-title="true"
      :show-close-button="true"
      :width="500"
      :height="150"
      title="Αναίρεση Οριστικοποίησης ΣΚΠ"
    >
      <div class="row">
        Είστε σίγουροι ότι θέλετε να αναιρέσετε την οριστικοποίηση της ΣΚΠ;
      </div>

      <div class="row" style="padding-top: 20px">
        <DxButton2
          class="pull-right"
          text="Ναι"
          type="success"
          :width="120"
          styling-mode="contained"
          @click="onUndoFinalizationApprove"
        />
        <DxButton2
          text="Όχι"
          type="danger"
          :width="120"
          styling-mode="contained"
          @click="onClosePopup"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import BackButton from "../../components/shared/backButton";
import { DxSelectBox } from "devextreme-vue/select-box";
import mainService from "../../services/mainService";

import { DxButton as DxButton2 } from "devextreme-vue/button";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxEditing,
  DxButton,
  DxMasterDetail,
} from "devextreme-vue/data-grid";
import DetailTemplate from "./paymentDetails";
import notify from "devextreme/ui/notify";
import paymentsUploadDocuments from "./paymentsUploadDocuments";
import paymentWizard from "./paymentWizard";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import { DxPopup } from "devextreme-vue/popup";

export default {
  components: {
    BackButton,
    DxSelectBox,
    DxLoadIndicator,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxEditing,
    DxButton,
    DxButton2,
    DxMasterDetail,
    DetailTemplate,
    paymentsUploadDocuments,
    paymentWizard,
    DxPopup,
  },
  data() {
    return {
      months: [],
      selectedMonthId: 0,
      payments: [],
      dataGridInstance: null,
      uploadPopupIsVisible: false,
      wizardPopupIsVisible: false,
      finalizationPopupIsVisible: false,
      undoFinalizationPopupIsVisible: false,
      selectedPaymentId: 0,
      allowedToDoActions: false,
      loadIndicatorVisible: false,
      duplicateReceiptNumbers: [],
    };
  },

  created() {},
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },

    async setSelectedMonth(e) {
      this.getPayments();
      this.dataGridInstance.collapseAll(-1);
    },
    onPaymentInfoViewerClick(e) {
      window.open(`${this.$PaymentController}/Index`, "_blank");
    },
    onPaymentInfoDownloadClick(e) {
      window.open(
        `${this.$PaymentController}/Index2?organizationId=${this.organizationId}&paymentId=${e.row.data.Id}`,
        "_self"
      );
    },
    async getMonths() {
      const res = await mainService.get(
        `/Periods/GetAvailableMonthsInActivePeriod`
      );
      this.months = res.data;
    },
    async getPayments() {
      this.loadIndicatorVisible = true;
      this.payments = [];
      if (this.hasFullAccess) {
        const res = await mainService.get(
          `/Payments/GetPaymentsByOrganizationAndMonth?organizationId=${this.organizationId}&month=${this.selectedMonthId}`
        );
        this.payments = res.data;
      } else {
        this.payments = [];
      }
      this.loadIndicatorVisible = false;
    },
    async onUploadClick(e) {
      this.selectedPaymentId = e.row.data.Id;
      this.uploadPopupIsVisible = true;
    },
    async onPaymentWizardClick(e) {
      this.selectedPaymentId = e.row.data.Id;
      this.wizardPopupIsVisible = true;
    },
    isFinalized(e) {
      return e.row.data.IsFinalized && this.allowedToDoActions;
    },
    isVisible(e) {
      var isFinalized = this.isFinalized(e);
      return isFinalized && (this.isAdmin || this.isSuperAdmin);
    },

    isNotFinalized(e) {
      return !e.row.data.IsFinalized && this.allowedToDoActions;
    },

    async onFinalizeClick(e) {
      //save pending changes

      if (e.row.isExpanded) {
        this.$refs.paymentDetails.$refs.dataGridDetail.$_instance.saveEditData();
      } else {
        e.component.expandRow(e.row.key);
        this.$refs.paymentDetails.$refs.dataGridDetail.$_instance.saveEditData();
      }

      // e.component.collapseAll(-1);
      // e.component.expandRow(e.row.key);

      //e.component.saveEditData();

      //check if payment can be finalized
      var result = await mainService.get(
        `/Payments/CanFinalize?paymentId=${e.row.data.Id}`
      );
      e.component.collapseAll(-1);
      e.component.expandRow(e.row.key);
      this.duplicateReceiptNumbers = result.data.DuplicateReceiptNumbers;
      this.payments[e.row.dataIndex].FinalizeCheck = true;

      e.component.expandRow(e.row.key);
      if (
        result.data.DuplicateReceiptNumbers.length > 0 ||
        result.data.HasEmptyOrNullValues ||
        result.data.IsDatesOutOfBounds
      ) {
        notify(
          "Δεν είναι δυνατή η οριστικοποίηση. Συμπληρώστε σωστά όλα τα πεδία και διορθώστε πιθανά λάθη",
          "error",
          4000
        );
      } else {
        this.selectedPaymentId = e.row.data.Id;
        this.finalizationPopupIsVisible = true;
      }
    },
    onUndoFinalization(e) {
      this.selectedPaymentId = e.row.data.Id;
      this.undoFinalizationPopupIsVisible = true;
    },
    async onFinalizationApprove() {
      const res = await mainService.put(
        `/Payments/FinalizePayment?paymentId=${this.selectedPaymentId}`
      );
      this.finalizationPopupIsVisible = false;
      if (res.status == 200) {
        notify(
          "Η οριστικοποίηση ολοκληρώθηκε με επιτυχία και τα στοιχεία βρίσκονται σε επεξεργασία.",
          "success",
          4000
        );
        this.getPayments();
      } else {
        notify(
          "Πρόβλημα κατά την οριστικοποίηση. Ελέγξτε ότι έχετε εισάγει σωστά τους Αριθμούς Παραστατικών και τις Ημερομηνίες Έκδοσης.",
          "error",
          5000
        );
      }
    },
    async onUndoFinalizationApprove() {
      const res = await mainService.post(
        `/Payments/UndoPaymentFinalization?paymentId=${this.selectedPaymentId}`
      );
      this.undoFinalizationPopupIsVisible = false;
      if (res.status == 200) {
        notify(
          "Η αποριστικοποίηση της πληρωμής πραγματοποιήθηκε με επιτυχία και μπορείτε να επεξεργαστείτε εκ νέου τα δεδομένα.",
          "success",
          4000
        );
        this.getPayments();
      } else {
        notify("Πρόβλημα κατά την αποριστικοποίηση.", "error", 5000);
      }
    },
    updateFinalizeCheck(paymentId) {
      this.payments.find((x) => x.Id == paymentId).FinalizeCheck = false;
    },
    onClosePopup(e) {
      this.finalizationPopupIsVisible = false;
      this.undoFinalizationPopupIsVisible = false;
    },
    HidePopup() {
      this.uploadPopupIsVisible = false;
    },
    HideWizardPopup() {
      this.wizardPopupIsVisible = false;
    },
  },
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
    hasFullAccess() {
      return this.$store.getters.getHasFullAccess;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  watch: {
    organizationId: async function (newValue, oldValue) {
      this.dataGridInstance.collapseAll(-1);
      this.getPayments();
    },
  },
  async mounted() {
    this.loadIndicatorVisible = true;
    this.getMonths();
    this.loadIndicatorVisible = false;

    var check = this.$moment();
    this.selectedMonthId = parseInt(check.format("M"));

    this.selectedMonthId = this.selectedMonthId == 1 ? 12 : this.selectedMonthId - 1;

    this.allowedToDoActions = !this.$store.getters.isUser;
  },
};
</script>

<style>
</style>